import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const uploadHandoutsApi = createAsyncThunk(
  "auth/handouts/upload",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.post(apiRoutes.globalsAction(`upload/assets`, 0), data, { headers: { "Content-Type": "multipart/form-data" } })

      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: "", loading: false, error: null, message: "" }
const uploadHandoutsSlice = createSlice({
  name: "handout_upload",
  initialState: { result: "", loading: false, error: null, message: "" },
  reducers: {
    resetHandoutUpload: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(uploadHandoutsApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(uploadHandoutsApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(uploadHandoutsApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetHandoutUpload } = uploadHandoutsSlice.actions;
export const uploadHandoutsReducer = uploadHandoutsSlice.reducer;
